import { Component, Input } from '@angular/core';
import { ModalData } from '../../models/modal-data.model';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'web-modal-card',
    templateUrl: './modal-card.component.html',
    styleUrls: ['./modal-card.component.scss'],
    imports: [CommonModule, IonicModule],
})
export class ModalCardComponent {
    @Input() modalData?: ModalData;
}
